import React from 'react';

interface Props {
  completionPct?: number | null;
  rubricScore?: number | null;
  rubricTier?: string | null;
}

const tierColor = (tier?: string | null): string => {
  switch ((tier || '').toLowerCase()) {
    case 'exceptional': return 'bg-green-100 text-green-800 border-green-200';
    case 'strong':      return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'adequate':    return 'bg-yellow-50 text-yellow-700 border-yellow-200';
    case 'weak':        return 'bg-orange-50 text-orange-700 border-orange-200';
    case 'critical_gap':return 'bg-red-50 text-red-700 border-red-200';
    default:            return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};

const completionColor = (pct: number): string => {
  if (pct >= 80) return 'bg-green-100 text-green-700 border-green-200';
  if (pct >= 50) return 'bg-blue-100 text-blue-700 border-blue-200';
  return 'bg-amber-100 text-amber-700 border-amber-200';
};

const DualScoreChip: React.FC<Props> = ({ completionPct, rubricScore, rubricTier }) => {
  const hasCompletion = completionPct !== undefined && completionPct !== null;
  const hasRubric = rubricScore !== undefined && rubricScore !== null;

  return (
    <div className="inline-flex items-center gap-1.5 flex-wrap">
      {hasCompletion && (
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium ${completionColor(
            completionPct || 0,
          )}`}
          title="Completion score — how much of the data-coverage rubric we filled in"
        >
          {completionPct}% complete
        </span>
      )}
      <span
        className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium ${
          hasRubric ? tierColor(rubricTier) : 'bg-gray-50 text-gray-500 border-gray-200'
        }`}
        title="Rubric score — quality / trust assessment, 0–100"
      >
        {hasRubric ? (
          <>
            <span className="font-semibold mr-1">{rubricScore}</span>
            <span className="text-[10px] uppercase">
              {(rubricTier || 'rubric').replace(/_/g, ' ')}
            </span>
          </>
        ) : (
          <span className="text-[10px] uppercase tracking-wide">Rubric pending</span>
        )}
      </span>
    </div>
  );
};

export default DualScoreChip;
